module.exports = __webpack_public_path__ + "img/2_204.6e32675b.png";